var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accountStateDiff"},[_c('difference-table',{attrs:{"dataRows":_vm.linesForDataRecord,"dataRecord":_vm.dataRecord,"description":"diffs"},on:{"saveRecord":_vm.saveRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }